export default __webpack_public_path__ + "static/media/cp_geo_lk.1ffbc386.svg";